import { Link, useLocation } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFound() {
  const location = useLocation();

  return (
    <main className="max-w-3xl mx-auto px-6 lg:px-8 py-20 text-center">
      <SEO
        title="Page not found"
        description="The requested Competition Checker page could not be found."
        path={location.pathname}
        noIndex
      />
      <div className="overline text-[var(--cc-gold)] mb-3">404</div>
      <h1 className="font-display text-3xl sm:text-4xl font-semibold text-white">
        Page not found
      </h1>
      <p className="mt-4 text-[var(--cc-text-muted)]">
        This page may have moved, expired, or never existed.
      </p>
      <Link
        to="/competitions"
        className="btn-gold inline-flex mt-8 px-5 py-3 rounded"
      >
        Browse competitions
      </Link>
    </main>
  );
}
